import { IconType } from '@meronex/icons';

/**
 * Esta función devuelve un ícono que puede ser usado por ejemplo en el
 * IconButton
 */
const makeIconFromUrl: (props: {
  className?: string;
  href: string;
}) => IconType = ({ className, href }) => {
  return function Icon() {
    return <img src={href} className={className} role="presentation" alt="" />;
  };
};

export default makeIconFromUrl;
